export const ADD_ITEMS_INITIAL_VALUE = { market: {}, fabricType: {}, category: [] };

export const RANGE_PLAN_TABLE_HEADER = (isShowTarget) => {
	return [
		{ title: 'Market', rowspan: 2, className: 'market-column' },
		{ title: 'Fabric Type', rowspan: 2, className: 'fabric-type-column' },
		{ title: 'TBO', rowspan: 2, className: 'tbo-column' },
		{ title: 'Category', rowspan: 2, className: 'category-column' },
		{ title: 'Techpack & Sample Quantity', colspan: isShowTarget ? 3 : 1 },
		{ title: 'Price Range', colspan: isShowTarget ? 2 : 1 },
		{ title: 'GSM Range', colspan: isShowTarget ? 2 : 1 },
		{ title: 'Fit Type', colspan: isShowTarget ? 2 : 1 },
		{ title: 'Fabric Category', colspan: isShowTarget ? 2 : 1 },
		{ title: 'Composition', colspan: isShowTarget ? 2 : 1 },
		{ title: '', rowspan: 2, className: 'action-column' }
	];
};

export const POPUP_VARIENTS = {
	INPUT: 'INPUT',
	DROP_DOWN: 'DROP_DOWN'
};

export const INITIAL_STATE = {
	min: '',
	max: ''
};

export const INITIAL_COMPOSITIONS = {
	composition_1: [
		{ fiberName: '', fiberDetails: {}, percentage: '', id: 1 },
		{ fiberName: '', fiberDetails: {}, percentage: '', id: 2 }
	]
};

export const ENTITY_TYPE = {
	FAVOURITE_FOLDER: 'FAVOURITE_FOLDER',
	COLLECTION: 'COLLECTION'
};

export const UPDATE_ENTITY_TYPE = {
	QUANTITY: 'QUANTITY',
	PRICE: 'PRICE',
	GSM: 'GSM',
	FIT_TYPE: 'FIT_TYPE',
	CONSTRUCTION: 'CONSTRUCTION',
	COMPOSITION: 'COMPOSITION'
};

export const checkValidId = (item) => {
	if (typeof item?.id === 'string' && item?.id?.includes('INDEX_')) {
		return null;
	} else {
		return item?.id;
	}
};

export const organizeResponse = (response, key = 'name') => {
	return response?.map((item) => ({
		...item,
		value: item?.id,
		label: item?.[key]
	}));
};

export const validatePopupRequiredFields = (values, fieldName, setErrors) => {
	const newErrors = {};
	if (!values.min || !values.max) {
		newErrors.min = `${fieldName} is required`;
		newErrors.max = `${fieldName} is required`;
	}
	if (parseFloat(values.min) > parseFloat(values.max)) {
		newErrors.min = `${fieldName} should be less than max ${fieldName}`;
	}
	setErrors(newErrors);
	return Object.keys(newErrors).length > 0;
};

export const getRangeValue = (min, max, isPrice = false) => {
	if (min && max) {
		return `${isPrice ? '$' : ''}${isPrice ? min.toFixed(2) : min} - ${isPrice ? '$' : ''}${
			isPrice ? max.toFixed(2) : max
		}`;
	} else if (min) {
		return `${isPrice ? '$' : ''}${isPrice ? min.toFixed(2) : min}`;
	} else if (max) {
		return `${isPrice ? '$' : ''}${isPrice ? max.toFixed(2) : max}`;
	}
	return '';
};

export const isAllowedToDelete = (item) =>
	!item?.achievedMaxGsm &&
	!item?.achievedMaxPrice &&
	!item?.achievedMinGsm &&
	!item?.achievedMinPrice &&
	!item?.achievedQuantity &&
	Object.keys(item?.achievedCompositionDetailsCountMap ?? {})?.length === 0 &&
	Object.keys(item?.achievedConstructionCountMap ?? {})?.length === 0 &&
	Object.keys(item?.achievedFitTypeCountMap ?? {})?.length === 0;

export const isAllowedToUpdateTarget = (item) =>
	item?.fabricType?.name !== 'NA' ||
	item?.parentCategory?.name !== 'NA' ||
	item?.categoryResponse?.name !== 'NA' ||
	item?.productGroupResponse?.name !== 'NA';

export const isCellIdMatched = (itemId, item) => {
	return item?.id === itemId && isAllowedToUpdateTarget(item);
};

export const groupByField = (field, rangePlanList) => {
	const groupedData = {};
	let currentId = null;
	let currentSum = 0;

	const getFieldInfo = (item) => {
		switch (field) {
			case 'parentCategory':
				return {
					isNew: item?.isNewParentCategory,
					id: item?.parentCategoryId
				};
			case 'fabricType':
				return {
					isNew: item?.isNewFabricType,
					id: item?.fabricTypeId
				};
			case 'productGroup':
				return {
					isNew: item?.isNewProductGroup,
					id: item?.mainProductGroupId
				};
			default:
				return {};
		}
	};

	rangePlanList?.forEach((item) => {
		const { isNew, id } = getFieldInfo(item);

		if (isNew) {
			if (currentId) {
				groupedData[currentId] = currentSum;
			}

			currentId = id;
			currentSum = Number(item?.achievedQuantity || 0);
		} else {
			currentSum += Number(item?.achievedQuantity || 0);
		}
	});

	if (currentId) {
		groupedData[currentId] = currentSum;
	}

	return groupedData;
};

export const calculateStylesCount = (rangePlanList = []) => {
	let costedStyles = 0;
	let inRangeStyles = 0;
	let outOfRangeStyles = 0;
	let sampleDevelopedStyles = 0;

	if (!Array.isArray(rangePlanList)) {
		return { costedStyles, inRangeStyles, outOfRangeStyles };
	}

	rangePlanList.forEach((item) => {
		if (!item) return;

		const totalCosted = Number(item?.totalCostedQuantity) || 0;
		const inRange = Number(item?.achievedBasePriceQuantity) || 0;

		if (totalCosted > 0) {
			costedStyles += totalCosted;
			inRangeStyles += inRange;
		}

		if (item?.sampleDevelopedQuantity > 0) {
			sampleDevelopedStyles += item?.sampleDevelopedQuantity;
		}
		if (item?.targetMaxPrice > 0 || item?.targetMinPrice > 0) {
			outOfRangeStyles += item?.totalCostedQuantity - item?.achievedBasePriceQuantity;
		}
	});

	return {
		costedStyles: Math.round(costedStyles),
		inRangeStyles: Math.round(inRangeStyles),
		outOfRangeStyles: isNaN(Math.round(outOfRangeStyles)) ? 0 : Math.round(outOfRangeStyles),
		sampleDevelopedStyles: Math.round(sampleDevelopedStyles)
	};
};

export const getReducedPrice = (value, percentage = 10) => {
	if (!value) return '';
	const reducedAmount = (parseFloat(value) * percentage) / 100;
	return value - reducedAmount;
};
